import { render, staticRenderFns } from "./hierarchy.vue?vue&type=template&id=3ed9b5b5&"
import script from "./hierarchy.vue?vue&type=script&lang=js&"
export * from "./hierarchy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3ed9b5b5')) {
      api.createRecord('3ed9b5b5', component.options)
    } else {
      api.reload('3ed9b5b5', component.options)
    }
    module.hot.accept("./hierarchy.vue?vue&type=template&id=3ed9b5b5&", function () {
      api.rerender('3ed9b5b5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/svg/hierarchy.vue"
export default component.exports